import { render, staticRenderFns } from "./DynamicComponents.vue?vue&type=template&id=2224ad4c&"
import script from "./DynamicComponents.vue?vue&type=script&lang=ts&"
export * from "./DynamicComponents.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicComponents.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports